import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHandenWassen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.4 5.5h6.83v1h-6.829A1.91 1.91 0 0 0 20.5 8.401v4.519h-1V8.398A2.91 2.91 0 0 1 22.398 5.5z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M15.22 12.92h9.57a4.45 4.45 0 0 1 4.45 4.45v17.92a.71.71 0 0 1-.71.71h-17a.71.71 0 0 1-.71-.71V17.37a4.45 4.45 0 0 1 4.45-4.45z"
    />
    <path
      fill="#00C5F2"
      d="M21.64 10.62h-3.28c-.37 0-.67.3-.67.67v3.17c0 .37.3.67.67.67h3.28c.37 0 .67-.3.67-.67v-3.17c0-.37-.3-.67-.67-.67"
    />
    <path
      fill="#85E3F9"
      d="M16.71 37.54a3.91 3.91 0 1 0 0-7.82 3.91 3.91 0 0 0 0 7.82M6.05 30.49a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9"
    />
    <path
      fill="#85E3F9"
      d="M13.46 31.68a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86M9.27 26.8a.98.98 0 1 0 0-1.96.98.98 0 0 0 0 1.96M15.2 22.16a.98.98 0 1 0 0-1.96.98.98 0 0 0 0 1.96M18.41 28.94a.98.98 0 1 0 0-1.96.98.98 0 0 0 0 1.96"
    />
    <path
      fill="#85E3F9"
      d="M10.08 38.31a4.88 4.88 0 1 0 0-9.76 4.88 4.88 0 0 0 0 9.76M31.87 13.36a2.64 2.64 0 0 1-5.28 0c0-1.48 2.64-5.32 2.64-5.32s2.64 3.84 2.64 5.32"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHandenWassen);

export default ForwardRef;
